/* Generado por el instalador. No editar a mano. */
export const CAMERAS_INSTALLED = true;

export function preload_VideoStreamViewer() { return import('../components/video-streaming/VideoStreamViewer'); }
export function loadCameraModule() { return import('../modules/video/VideoModuleIntegration'); }
export { default as VideoStreamViewer } from '../components/video-streaming/VideoStreamViewer';
export { default as CameraDiscoveryTab } from '../components/video-streaming/CameraDiscoveryTab';
